import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from "@ionic/react"
import { closeOutline } from "ionicons/icons"

export const ModalHeader = ({title, dismissModal}:{title:string, dismissModal: any}) => {
    return (
        <IonHeader>
            <IonToolbar>
                <IonTitle>{title}</IonTitle>
                <IonButtons slot="end">
                    <IonButton onClick={dismissModal}>
                        <IonIcon icon={closeOutline} />
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>
    )
}

